export const reactSelectOptionClasses = '!text-sm !my-0 !py-0';
